import {ApplicationRef, Injectable,} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ActionQuestionOverlayService {

  questionModals = {};

  constructor(private applicationRef: ApplicationRef) {
  }

  init() {
    (window as any).NG_SHARED_ACTION_QUESTION_OVERLAY_SERVICE  = this;
  }

  showQuestions(id: string, table: string, options: any): Promise<string> {
    options = options || {};
    const nlu_match: any = options.nlu_match;
    const requestID = options.requestID;
    const sourceRec = options.sourceRec;
    const sourceIsNewRecord = options.sourceIsNewRecord == null ? false : options.sourceIsNewRecord;

    const key = id + table;

    if (!this.questionModals[key]) {
      return new Promise((resolve, reject) => {
        const questionOverlay = document.createElement("sb-ng-action-question-overlay");

        (questionOverlay as any).recordId = id;
        (questionOverlay as any).recordTable = table;
        (questionOverlay as any).nluModel = nlu_match;
        (questionOverlay as any).requestID = requestID;
        (questionOverlay as any).sourceRec = sourceRec;
        (questionOverlay as any).sourceIsNewRecord = sourceIsNewRecord;

        (questionOverlay as any).resolve = (val: any) => {
          delete this.questionModals[key];
          if (val) {
            resolve(val);
          } else {
            reject(null);
          }
        };

        document.body.appendChild(questionOverlay);

        (questionOverlay as any).show();

        this.questionModals[key] = true;

        this.applicationRef.tick(); // Is this needed?
      });
    } else {
      return Promise.reject(null);
    }
  }

  deregisterModal(id: string, table: string) {
    const key = id + table;
    delete this.questionModals[key]
  }
}
